module.exports = __webpack_public_path__ + "static/media/drop_off.7e0aeea0.png";